export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    public readonly details: Record<string, unknown> = {},
  ) {
    super(code);
  }
  get fields(): Record<string, string> {
    return (this.details.fields as Record<string, string>) ?? {};
  }
}

type Method = "GET" | "POST";

/** Calls the driver API (`/api/driver/...`). Authentication: httpOnly driver session cookie. */
export async function api<T = unknown>(path: string, options: { method?: Method; body?: unknown } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api/driver${path}`, {
      method: options.method ?? "GET",
      credentials: "same-origin",
      headers: options.body !== undefined ? { "Content-Type": "application/json" } : undefined,
      body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
    });
  } catch {
    throw new ApiError(0, "NETWORK");
  }
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const { code = "INTERNAL_ERROR", ...details } = (data?.error ?? {}) as { code?: string } & Record<string, unknown>;
    if (res.status === 401 && !path.startsWith("/auth/")) window.dispatchEvent(new Event("tw-driver-unauthorized"));
    throw new ApiError(res.status, code, details);
  }
  return data as T;
}
